import {BorderType} from '@PosterWhiteboard/classes/item-border.class';
import type {RGBA} from '@Utils/color.util';

interface PMWShapeToLineMap {
  fillColor: RGBA;
  borderThickness: number;
  borderType: BorderType;
  borderColor: RGBA;
  width: number;
  height: number;
}

export const PMW_SHAPE_TO_LINE_HASHMAP: Record<string, PMWShapeToLineMap> = {
  '1240': {
    fillColor: [0,0,0,1],
    borderType: BorderType.NONE,
    borderThickness: 0,
    borderColor: [166, 89, 118, 1],
    width: 180,
    height: 3,
  }
};
